export const HIGHLIGHTED_TEXT_OPACITY = 1;
export const REGULAR_TEXT_OPACITY = 0.7;
export const ICON_WIDTH = 36;
